var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#abb3ba",
  d: "M2.8 4a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4m12.728 3.664-7.2-7.2A1.6 1.6 0 0 0 7.2 0H1.6C.712 0 0 .712 0 1.6v5.6c0 .44.176.84.472 1.128l7.192 7.2c.296.288.696.472 1.136.472s.84-.184 1.128-.472l5.6-5.6C15.824 9.64 16 9.24 16 8.8c0-.448-.184-.848-.472-1.136"
})));
export default SvgTag;